import PaysEntete from './pays.entete.model';

export default class PaysFormEnteteController {
	static $inject = ['$state', '$stateParams', 'PaysService', 'ModalService', 'notification', 'FacturesXService'];

	constructor($state, $stateParams, PaysService, ModalService, notification, FacturesXService) {
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.PaysService = PaysService;
		this.ModalService = ModalService;
		this.notification = notification;
		this.FacturesXService = FacturesXService;
	}

	async $onInit() {
		this.pays = this.pays || {};
		this.entete = new PaysEntete(this.pays.entete);
		this.devise = this.devise || {};

		this.codesFactureX = await this.FacturesXService.getDataByDomaine('pays');
	}

	$onChanges(objChanges) {
		if (objChanges.pays) {
			this.getDevises();
		}
	}

	$doCheck() {
		if (!angular.equals(this.entete, this.pays.entete)) {
			this.onUpdate({
				entete: angular.copy(this.entete)
			});
		}
	}

	async checkCodeUnicity(code) {
		if (code) {
			this.startCodeLoading();

			try {
				if (code.match(/^[a-zA-Z0-9_|]*$/)) {
					this.entete.codeExists = await this.PaysService.codeExists(code);
				}
			} catch (ex) {
				this.notification.error(ex.data);
			} finally {
				this.stopCodeLoading();
			}
		} else {
			this.entete.codeExists = null;
		}
	}

	async getDevises() {
		this.startLoading();
		try {
			const res = await this.PaysService.getDevises();
			this.deviseListe = res.items;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	startCodeLoading() {
		this.codeLoading = true;
	}

	stopCodeLoading() {
		this.codeLoading = false;
	}
}
